<template>
  <div id="app">
    <!-- Ici on pourrait mettre une barre de navigation globale ou un en-tête -->
    <router-view />
    <!-- C'est ici que les vues (MeetingListView, MeetingDetailView) seront affichées -->
  </div>
</template>

<style lang="scss">
// Styles généraux de l'application (appliqués à l'ensemble du DOM)
// Les styles spécifiques aux composants iront dans les sections <style scoped>
</style>
